module.exports = __webpack_public_path__ + "static/media/014.a4167370.jpg";